import { useEffect as o } from "react";
const d = ({
  ref: t,
  fn: e,
  isEnabled: u = !0
}) => {
  const n = (i) => {
    var c;
    !u || !(t != null && t.current) || (c = t == null ? void 0 : t.current) != null && c.contains(i.target) || e();
  };
  o(() => (document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  }));
};
export {
  d as default
};
//# sourceMappingURL=useOutsideClick.mjs.map
